<template>
  <div class="app-container">
    <list ref="list" @deleted="reload" @reviewed="reload">
        <template slot="toolbar-right" v-if="$permission.canWrite()">
          <el-button type="info" @click="onPrintTemaplate">打印模板</el-button>
            <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
            <el-button type="primary" @click="review" >批量审核</el-button>

            <el-button type="danger" @click="del">删除</el-button>

        </template>
        <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="100">
              <template slot-scope="{row}">
                <template v-if="row.Status < 2">
                  <template v-if="$permission.canWrite()">
                    <el-button type="text" @click.stop="edit(row)">编辑</el-button>
                  </template>
                  <!-- <el-button v-if="$permission.canReview()" type="text" @click.stop="review(row.DocId)">
                    <span>审核</span>
                  </el-button> -->
                </template>
                <el-button type="text" v-else @click.stop="edit(row)">查看</el-button>
                
                <el-button type="text" @click="onPrint2(row)">打印2</el-button>
              </template>
                <!-- <template slot-scope="{row}">
                    <el-button v-if="$permission.canWrite() && row.Status !== 2" @click="edit(row)" type="text" >
                      编辑
                    </el-button>
                    <el-button v-if="$permission.canReview()" type="text" @click="edit(row)">审核</el-button>
                </template> -->
            </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/finance/cashier/payment/list'

export default {
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
      api: require("@/api/rp/pay").default,
    }
  },
  methods: {
    onPrint2(row) {
      var url = location.origin + "/#/customprintview/付款单/" + row.DocId;
      window.open(url, "_blank");
    },
    onPrintTemaplate() {
      var url = location.origin + "/#/customprint/" + "付款单";
      window.open(url, "_blank");
    },
    review(){
      this.$refs.list.review();
    },
    edit({DocId}){
       let id = DocId;
      var loading = this.$loading({
        lock: true,
        text: "正在查询...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
       this.api.info(id).then(res => {
        if(res.Code === 0){
          loading.close()
          this.toURL({
            name: 'editpayment',
            params: {
              type: 'edit',
              data: res.Data
            }
          })
        }else{
          loading.close()
          this.$message({type: 'warning', message: res.Msg})
        }
       }).catch(err => {
          loading.close()
       })

       
    },
    create(){
      
      this.toURL({
        name: 'editpayment',
        params: {
          type: 'create'
        }
      })

    },
    toURL(o){
      this.$router.push(o)
    },
    del(){
      this.$refs.list.del()
    },
  }
  
};
</script>